import React from 'react';
import './OfflineStatus.css';

export default ({status, newContentAvailable}) => {
  if ( !status ) {
    return (
      <div className="OfflineStatus">
        Unable to connect to server
        <div>
          <small>Some features will not be available while we try to reconnect..</small>
        </div>
      </div>
    )
  } else if ( newContentAvailable ) {
    return (
      <div className="NewContentAvailable" onClick={() => window.location.reload()}>
        <h3> New features available - click here to refresh </h3>
      </div>
    )
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/component/organisms/OfflineStatus/component.js